import React, {useState, useEffect, useRef, forwardRef, useImperativeHandle,useMemo } from 'react';
import AssetService from "../../services/AssetService";
import FacilityService from "../../services/FacilityService";
import { If } from "../../utils/Controls";
import { AntdPaging, AntdSelect, AntdDatepicker } from "../../utils/Antd";
import util from "../../utils/util";
import plus from './icons/plus.svg'
import search from './icons/magnifying-glass-solid.svg'
import pen from './icons/pen-to-square-solid.svg'
import share from './icons/share-solid.svg'
import { Table, Typography } from 'antd';
//import { useState, forwardRef, useImperativeHandle } from 'react';

import {
    Input,
    Button,
    message,
    Modal,
    Segmented,
    Tabs
} from 'antd';

export default function Assets() {
    const [clients, setClients] = useState([]);
    const [items, setItems] = useState([]);
    const [stationPoints, setStationPoints] = useState([]);
    //const [functionalStatus, setFunctionalStatus] = useState([]);
    const [supplier_name, setSuppliers] = useState([]);
    
    const onTabChange = (key) => {
        setTab(key);
    }

    useEffect(() => {
        FacilityService.all({ status: 1, include_me: 'Y' }).then(res => {
            let allClients = res.data.result.data.map(v => { return { id: v.id, name: v.business_name, is_national: v.is_national, is_me: v.is_me } });
            setClients(allClients);
        });

        FacilityService.allStationPoints({ status: 1 }).then(res => {
            setStationPoints([...res.data.result.data]);
        });
        
        AssetService.allSuppliers().then(res => {
            setSuppliers([...res.data.data]);
        })
    }, []);
    
    const modules = util.getModules();
    const tabItems = [
        { k: 'Expenditure', v: 'Expenditure', cat_type: 'Infrastructure', asset_cat_id: '6' },
        { k: 'Revenue', v: 'Revenue', cat_type: 'Infrastructure', asset_cat_id: '7' }
       ];
      
      const filteredItems = tabItems.filter(item => {
        if (item.k === 'Expenditure' && modules.infrastructure === 1) return true;
        if (item.k === 'Revenue' && modules.infrastructure === 1) return true;
       return false;
      });
      const [tab, setTab] = useState(filteredItems.length > 0 ? filteredItems[0].k : '');
     
    return (
        <div className="page-content">
            <div className="page-head uc d-flex">
                <div className="my-auto">
                    <h2>Expenditure</h2>
                </div>
                <div className="my-auto ml-auto"></div>
            </div>

            <div className="page-pad">
                <Tabs
                    activeKey={tab}
                    destroyInactiveTabPane
                    onChange={onTabChange}
                    items={filteredItems.map(rw => ({
                        key: rw.k,
                        label: rw.v,
                        children: (
                            <List
                                //vendors={vendors}
                                items={items}
                                stationPoints={stationPoints}
                                supplier_name={supplier_name}
                                cat_type={rw.cat_type}
                                cat={rw.k}
                                asset_cat_id = {rw.asset_cat_id}
                                clients={clients} 
                            />
                        )
                    }))}
                />

                {}
            </div>
        </div>
    )
}

function List(props) {
    const [result, setResult] = useState({ data: [], page: {} });
    const sdataRef = useRef({ p: 1, ps: 25 });
    const formRef = useRef();
    //const transferFormRef = useRef();
    const [clients, setClients] = useState([]);
    const [items, setItems] = useState([]);
    const [stationPoints, setStationPoints] = useState([]);
    const [supplier_name, setSuppliers] = useState([]);
    const [checkbox, setCheckbox] = useState([]);
    const isNational = util.isNational();
    const modules = util.getModules();


    const list = (p, ps) => {
        sdataRef.current.p = p || 1;
        sdataRef.current.ps = ps || sdataRef.current.ps;
        sdataRef.current.cat_type = props.cat_type;
        sdataRef.current.cat = props.cat;
        sdataRef.current.asset_cat_id=props.asset_cat_id; 

       
        util.showLoader();
        AssetService.lists(sdataRef.current).then(({ data }) => {
       
        const filteredData = data.result.data.filter(item => item.asset_cat_id === props.asset_cat_id);
        setResult({ ...data.result, data: filteredData });
            
        }).catch(e => {
            message.error(e.message);
        }).finally(() => {
            util.hideLoader();
        });
        
    }

    const handleCheckbox = (e, id, allSelect = false) => {
        let dt = checkbox;
        if (!allSelect) {
            if (e.target.checked) {
                dt = [...new Set(dt)];
                dt.push(id)
            } else {
                dt.splice(dt.indexOf(id), 1);
                dt = [...new Set(dt)]; 
            }
        } else {
            dt = [];
            if (e.target.checked) {
                result.data.map(v => dt.push(v.id));
            }
        }
        setCheckbox([...dt])
    }

    useEffect(() => {
        setClients(props.clients);
    }, [props.clients]);

AssetService.allItems({ status: 1,asset_cat_id:props.asset_cat_id}).then(res => {
    
        let allItems = [];
        allItems = res.data.result.data.map((v) => {
            if (v.cat_type === 'Med/NonMed') {
                v.item_full_name = v.item_full_name + ' [' + v.cat + ']';
            } else {
                v.item_full_name = v.item_full_name + ' [' + v.subcat + ']';
            }
            return v;
        });
       
        setItems(allItems);
    });

    useEffect(() => {
        setStationPoints(props.stationPoints);
    }, [props.stationPoints]);

    useEffect(() => {
        setSuppliers(props.supplier_name);
    }, [props.supplier_name]);

    useEffect(() => {
        list();

        return () => { message.destroy() }
    }, []);

    return (
        <div className="">
            <div className="">
                <div className="d-flex mb8">
                    <div className="text-secondary my-auto">
                        {result.data.length > 0 &&
                            <div>
                                Showing {result.page.start + 1} - {result.page.start + result.page.total} of {result.page.total_records} records.
                            </div>
                        }
                    </div>
                    <div className="ml-auto my-auto">

                        {modules['add_asset'] === 1 &&
                            <Button size="small" type="primary" onClick={() => formRef.current.openForm()}><img src={plus} alt='login' className='h-1 mr5' fill="white" height={13} />
                                Record
                            </Button>
                        }
                    </div>
                </div>

                <div className="tbl-search-head">
                    <SearchForm
                        dataRef={sdataRef}
                        clients={clients}
                        supplier_name={supplier_name}
                        stationPoints={stationPoints}
                        cat_type={props.cat_type}
                        isNational={isNational}
                        asset_cat_id={props.asset_cat_id}
                        onSearch={list}
                    />
                </div>
                <If cond={result.data.length}>
    <div className="table-responsive">
        <table className="table table-bordered table-sm font-xs table-striped table-hover m-0">
            <thead className="thead-light text-uppercase table-text-vmid pad-y-md">
                <tr>
                    <th className="w20">
                        <input type="checkbox" checked={(() => {
                            let flag = true;
                            result.data.forEach(v => {
                                if (!checkbox.includes(v.id)) {
                                    flag = false;
                                }
                            });
                            return flag;
                        })()}
                        onChange={(e) => handleCheckbox(e, 0, true)}
                        />
                    </th>

                    {isNational === 1 && <th className="w100">Facility</th>}
                    
                    <th>Supplier Name</th>
                    <th className="w100">Month</th>
                    
                        <th className="w100">Line Item</th>
                    
                            <th className="w100 nowrap">Amounts (SZL)</th>
                            <th className="w100">Status</th>
                     
                    <th className="w100 text-right">Fiscal year period</th>
                    <th className="w100 text-right">EFT Number</th>
                    
                            <th className="w100">Green copy date</th>
                            <th className="w130">Central Bank Swift</th>
                     
                    <th className="w120">Comment</th>
                </tr>
            </thead>
            <tbody className="table-text-top font-sm">
                {result.data.sort((a, b) => {
                    // Sort by item
                    if (a.item < b.item) return -1;
                    if (a.item > b.item) return 1;

                    // If items are the same, sort by procurement_date
                    const dateA = new Date(a.eimonth);
                    const dateB = new Date(b.eimonth);
                    return dateA - dateB;
                }).map((v, i) => {
                    let backgroundColor;
                    switch (v.eistatus) {
                        case 'Commitments/Orders':
                            backgroundColor = 'purple';
                            break;
                        case 'Cancelled Orders':
                            backgroundColor = 'red';
                            break;
                        case 'On Desk':
                            backgroundColor = 'orange';
                            break;
                        case 'Checking':
                            backgroundColor = 'brown';
                            break;
                        case 'At EFT':
                            backgroundColor = 'yellow';
                            break;
                        case 'Paid to Supplier':
                            backgroundColor = 'Green';
                            break;
                    }
   
    
    
                    return (

                        
    
                        <tr key={i}>
                            <td>
                                <input type="checkbox" checked={checkbox.includes(v.id) ? true : false} onChange={(e) => handleCheckbox(e, v.id)} />
                            </td>
                            {isNational === 1 && 
                            <td>

                                {v.client} <div style={{ marginTop: '4px', color: 'green', fontWeight: 900 }}>RC:
                                {v.site_code}   </div> 
                            </td>
                            }

                            <td>
                                {v.eirc}
                            
                                    <div style={{ marginTop: '4px', color: 'purple', fontWeight: 700 }}>{v.eircname}</div>
                                
                            </td>
                            <td>
                                     <div className="uc bold600">{v.eisuppliername}</div>
                                     <div className="pt3 note-text">
                                    <div className="d-flex"><div className="w90">Order Number</div> : <div className="bold600 pl5">{v.eiordernumber}</div></div>
                                    <div className="d-flex"><div className="w90">Order Issue Date</div> : <div className="bold600 pl5">{v.eiorderissuedate}</div></div>
                                    <div className="d-flex"><div className="w90">Invoice Number</div> : <div className="bold600 pl5">{v.eiinvoicenumber}</div></div>
                                    <div className="d-flex"><div className="w90">Invoice Date</div> : <div className="bold600 pl5">{v.eiinvoicedate}</div></div>
                                </div>
                            </td>
                            <td>{v.eimonth}</td>
                            <td>
                                <div className="uc bold600">{v.item}</div>
                                    <div className="pt3 note-text">
                                    <div className="d-flex"><div className="w90">Unique Identifier</div> : <div className="bold600 pl5">{v.eiuniqueidentifier}</div></div>
                                    <div className="d-flex"><div className="w90">Project Number</div> : <div className="bold600 pl5">{v.eiprojectnumber}</div></div>
                                    <div className="d-flex"><div className="w90">Voucher Number</div> : <div className="bold600 pl5">{v.eivouchernumber}</div></div>
                                    <div className="d-flex"><div className="w90">Batch Number</div> : <div className="bold600 pl5">{v.eibatchnumber}</div></div>
                                </div>

                            </td>
                            <td>
                                
                                    <div className="pt3 note-text">
                                    <div className="d-flex"><div className="w90">Net Amount</div> : <div className="bold600 pl5">E{v.einetamount}</div></div>
                                    <div className="d-flex"><div className="w90">Vat Amount</div> : <div className="bold600 pl5">E{v.eivatamount}</div></div>
                                    <div className="d-flex"><div className="w90">Interest Amount</div> : <div className="bold600 pl5">E{v.eiinterestamount}</div></div>
                                    <div className="d-flex"><div className="w90">EWSC Amount</div> : <div className="bold600 pl5">E{v.eiewscamount}</div></div>
                                    <div className="d-flex"><div className="w90">EEC Amount</div> : <div className="bold600 pl5">E{v.eieecamount}</div></div>
                                </div>

                            </td>
    
                                <td style={{ backgroundColor }}>{v.eistatus}</td>
                                 <td>{v.eifiscalyearperiod}</td>
                                  <td>{v.eieftnumber}</td>
                                   <td>{v.eigreencopydate}</td>
                                    <td>{v.eicentralbankswift}</td>
                                     <td>{v.eicomment}</td>
                            
                            <td className="text-center">
                                <Button.Group size="small">
                                    <Button type="default" onClick={() => formRef.current.openForm(v)}><img src={pen} alt='login' className='h-1 mr5' height={15} /></Button>
                                    {/* <Button type="default" onClick={() => deleteRecord(v.id)}><i className="fa fa-times-circle font-red"></i></Button> */}
                                </Button.Group>
                            </td>
                        </tr>
                    );
                })}
            </tbody>
        </table>
    </div>
    <div className="d-flex tbl-foot-bx">
        <AntdPaging
            onChange={list}
            total={result.page.total_records}
            current={result.page.cur_page}
            pageSize={sdataRef.current.ps}
            showSizeChanger
        />
    </div>
</If>
<If cond={!result.data.length}>
    <div className="no-rec">No record found</div>
</If>
            </div>

            <BulkAddForm
                ref={formRef}
                pageno={sdataRef.current.p}
                clients={clients}
                
                items={items}
                stationPoints={stationPoints}
//                functionalStatus={functionalStatus}
                cat_type={props.cat_type}
                asset_cat_id={props.asset_cat_id}
                isNational={isNational}
                callback={list}
            />

        </div>
    )
}

const SearchForm = (props) => {
    let { dataRef, onSearch, clients, supplier_name, isNational, cat_type,asset_cat_id } = props;
    let [data, setData] = useState({ ...dataRef.current, station_point_ids: [], isdonated: null });
    //let [supplier_name, setStationPoints] = useState([]);
    const [items, setItems] = useState([]);
                

    const handleChange = (v, k) => {
        data[k] = v;
        if (k === 'client_id') {
            data.station_point_ids = [];
        }
        setData({ ...data });
    }
    useEffect(() => {
        dataRef.current = { ...data };
    }, [data]);

    useEffect(() => {
        if (isNational === 1) {
            setData({ ...data, client_id: null });
        } else {
            let ob = clients.find(v => v.is_me);
            setData({ ...data, client_id: ob?.id });
        }
    }, [clients]);


    useEffect(() => {
        setData({ ...data, p: dataRef.current.p, ps: dataRef.current.ps });
    }, [dataRef.current.p, dataRef.current.ps]);

    useEffect(() => {
        AssetService.allItems({ status: 1, cat_type,asset_cat_id,client_id: data.client_id, availableAssetsOnly: 'Y' }).then(res => {
            let allItems = [];
            allItems = res.data.result.data.map((v) => {
                if (v.cat_type === 'Med/NonMed') {
                    v.item_full_name = v.item_full_name + ' [' + v.cat + ']';
                } else {
                    v.item_full_name = v.item_full_name + ' [' + v.subcat + ']';
                }
                return v;
            });
            setItems(allItems);
        });
    }, [cat_type, data.client_id]);

    return (
        <form onSubmit={e => e.preventDefault()} autoComplete="off" spellCheck="false">
            <div className="d-flex">
                {isNational === 1 &&
                    <div className="w150 mr5">
                        <div className="text-secondary fs11 mb2">Facility</div>
                        <AntdSelect
                            placeholder="All Facilities"
                            allowClear
                            showSearch
                            options={clients}
                            value={data.client_id}
                            onChange={v => {
                                data.item_id = null;
                                handleChange(v, 'client_id');
                            }}
                        />
                    </div>
                }

    <div className="w170 mr5">
    <div className="text-secondary fs11 mb2">Status</div>
    <AntdSelect
        placeholder="All Statuses"
        allowClear
        showSearch
        options={[
            { label: 'Commitments/Orders', value: 'Commitments/Orders' },
            { label: 'Cancelled Orders', value: 'Cancelled Orders' },
            { label: 'On Desk', value: 'On Desk' },
            { label: 'Checking', value: 'Checking' },
            { label: 'At EFT', value: 'At EFT' },
            { label: 'Paid to Supplier', value: 'Paid to Supplier' }
        ]}
        value={data.eistatus}
        onChange={v => handleChange(v, 'eistatus')}
    />
</div>

                <div className="w350 mr5">
                    <div className="text-secondary fs11 mb2">Item</div>
                    <AntdSelect
                        placeholder="Item (All)"
                        allowClear
                        showSearch
                        options={items.map(v => { return { id: v.id, name: v.item_full_name } })}
                        value={data.item_id}
                        onChange={v => handleChange(v, 'item_id')}
                    />
                </div>


                {}

                <div className="w210 mr5">
                    
                <div className="text-secondary fs11 mb2">Supplier Name</div>
                    <AntdSelect
                            placeholder="All Suppliers"
                            allowClear
                            showSearch
                            options={supplier_name}
                            value={data.supplier_name}
                            onChange={v => {
                                data.supplier_name = null;
                                handleChange(v, 'supplier_name');
                            }}
                        />
                </div>

                <div className="w210 mr5">

                <div className="text-secondary fs11 mb2">Batch Number</div>
                    <Input placeholder="Batch Number" 
                        allowClear value={data.batch_number}
                         onChange={e => handleChange(e.target.value, 'batch_number')} />
                </div>
              

                <div className="w210 mr5">
                    <div className="text-secondary fs11 mb2">Order Number</div>
                    <Input placeholder="Order Number" 
                        allowClear value={data.eiorder_number}
                         onChange={e => handleChange(e.target.value, 'eiorder_number')} />
                </div>
                <div className="pt15">
                    <Button className="mt4" type="primary" onClick={() => onSearch()}><img src={search} alt='login' className='h-1 mr5'  height={15} /></Button>
                </div>
            </div>
        </form>
    )
}
const { Text } = Typography;
const BulkAddForm = forwardRef((props, ref) => {
    let { callback, pageno, clients, stationPoints, functionalStatus, cat_type, items } = props;
    const [showForm, setShowForm] = useState(false);
    const [records, setRecords] = useState([]);

    // Create a new empty financial record row
    const createNewRecord = (client_id = null) => ({
        id: Date.now() + Math.random(), // temporary ID for React keys
        client_id,
        supplier_name: '',
        month: null,
        item_id: null,
        fiscal_year_period: '',
        eft_number: '',
        green_copy_date: null,
        central_bank_swift: '',
        comment: '',
        order_number: '',
        order_issue_date: null,
        invoice_number: '',
        invoice_date: null,
        unique_identifier: '',
        project_number: '',
        voucher_number: '',
        batch_number: '',
        net_amount: '',
        vat_amount: '',
        interest_amount: '',
        ewsc_amount: '',
        eec_amount: '',
        status: ''
    });

    // Add a new row
    const addRow = () => {
        let client_id = null;
        let ob = clients.find(v => v.is_me);
        client_id = ob?.id;
        
        setRecords([...records, createNewRecord(client_id)]);
    };

    // Remove a row
    const removeRow = (index) => {
        const newRecords = records.filter((_, i) => i !== index);
        setRecords(newRecords);
    };

    // Update a specific field in a specific row
    const updateRecord = (index, field, value) => {
        const newRecords = [...records];
        newRecords[index] = { ...newRecords[index], [field]: value };
        setRecords(newRecords);
    };

    // Save all records
    const saveAll = async () => {
        if (records.length === 0) {
            message.warning('Please add at least one record');
            return;
        }

        // Validate required fields
        const errors = [];
        records.forEach((record, index) => {
            if (!record.client_id) errors.push(`Row ${index + 1}: Facility is required`);
            if (!record.supplier_name) errors.push(`Row ${index + 1}: Supplier Name is required`);
            if (!record.month) errors.push(`Row ${index + 1}: Month is required`);
            if (!record.item_id) errors.push(`Row ${index + 1}: Line Item is required`);
            if (!record.amounts) errors.push(`Row ${index + 1}: Amounts (SZL) is required`);
            if (!record.fiscal_year_period) errors.push(`Row ${index + 1}: Fiscal Year Period is required`);
            if (!record.unique_identifier) errors.push(`Row ${index + 1}: Unique Identifier is required`);
        });

        if (errors.length > 0) {
            message.error(errors.join('\n'));
            return;
        }

        message.destroy();
        util.showLoader();

        try {
            // Save records one by one or batch save if your API supports it
            const savePromises = records.map(record => {
                const { id, ...recordData } = record; // Remove temporary ID
                return AssetService.saveExpenditure(recordData); // Update service call as needed
            });

            await Promise.all(savePromises);
            message.success(`Successfully saved ${records.length} record(s)`);
            callback(1);
            setShowForm(false);
        } catch (e) {
            message.error(e.message || 'Error saving record');
        } finally {
            util.hideLoader();
        }
    };

    const closeForm = () => {
        setShowForm(false);
        setRecords([]);
    };

    useImperativeHandle(ref, () => ({
        openForm() {
            let client_id = null;
            let ob = clients.find(v => v.is_me);
            client_id = ob?.id;
            
            // Start with one empty row
            setRecords([createNewRecord(client_id)]);
            setShowForm(true);
        }
    }));

    const columns = [
        {
            title: 'Facility*',
            width: 150,
            fixed: 'left',
            render: (_, record, index) => (
                <AntdSelect
                    showSearch
                    size="small"
                    options={clients}
                    value={record.client_id}
                    onChange={v => updateRecord(index, 'client_id', v)}
                    style={{ width: '100%' }}
                />
            )
        },
        {
            title: 'Supplier Name*',
            width: 150,
            render: (_, record, index) => (
                <Input
                    size="small"
                    value={record.supplier_name}
                    onChange={e => updateRecord(index, 'supplier_name', e.target.value)}
                />
            )
        },
        {
            title: 'Order Number',
            width: 120,
            render: (_, record, index) => (
                <Input
                    size="small"
                    value={record.order_number}
                    onChange={e => updateRecord(index, 'order_number', e.target.value)}
                />
            )
        },
        {
            title: 'Order Issue Date',
            width: 130,
            render: (_, record, index) => (
                <AntdDatepicker
                    size="small"
                    value={record.order_issue_date}
                    onChange={v => updateRecord(index, 'order_issue_date', v)}
                    style={{ width: '100%' }}
                />
            )
        },
        {
            title: 'Invoice Number',
            width: 120,
            render: (_, record, index) => (
                <Input
                    size="small"
                    value={record.invoice_number}
                    onChange={e => updateRecord(index, 'invoice_number', e.target.value)}
                />
            )
        },
        {
            title: 'Invoice Date',
            width: 130,
            render: (_, record, index) => (
                <AntdDatepicker
                    size="small"
                    value={record.invoice_date}
                    onChange={v => updateRecord(index, 'invoice_date', v)}
                    style={{ width: '100%' }}
                />
            )
        },
        
        {
            title: 'Month*',
            width: 130,
            render: (_, record, index) => (
                <AntdDatepicker
                    size="small"
                    picker="month"
                    value={record.month}
                    onChange={v => updateRecord(index, 'month', v)}
                    style={{ width: '100%' }}
                />
            )
        },
        {
            title: 'Line Item*',
            width: 150,
            render: (_, record, index) => (
                <AntdSelect
                    showSearch
                    size="small"
                    options={items.map(v => ({ id: v.id, name: v.item_full_name }))}
                    value={record.item_id}
                    onChange={v => updateRecord(index, 'item_id', v)}
                    style={{ width: '100%' }}
                />
            )
        },
        
        {
            title: 'Unique Identifier*',
            width: 140,
            render: (_, record, index) => (
                <Input
                    size="small"
                    value={record.unique_identifier}
                    onChange={e => updateRecord(index, 'unique_identifier', e.target.value)}
                />
            )
        },
        {
            title: 'Project Number',
            width: 120,
            render: (_, record, index) => (
                <Input
                    size="small"
                    value={record.project_number}
                    onChange={e => updateRecord(index, 'project_number', e.target.value)}
                />
            )
        },
        {
            title: 'Voucher Number',
            width: 120,
            render: (_, record, index) => (
                <Input
                    size="small"
                    value={record.voucher_number}
                    onChange={e => updateRecord(index, 'voucher_number', e.target.value)}
                />
            )
        },
        {
            title: 'Batch Number',
            width: 120,
            render: (_, record, index) => (
                <Input
                    size="small"
                    value={record.batch_number}
                    onChange={e => updateRecord(index, 'batch_number', e.target.value)}
                />
            )
        },
        {
            title: 'Net Amount',
            width: 120,
            render: (_, record, index) => (
                <Input
                    size="small"
                    type="number"
                    value={record.net_amount}
                    onChange={e => updateRecord(index, 'net_amount', e.target.value)}
                />
            )
        },
        {
            title: 'VAT Amount',
            width: 120,
            render: (_, record, index) => (
                <Input
                    size="small"
                    type="number"
                    value={record.vat_amount}
                    onChange={e => updateRecord(index, 'vat_amount', e.target.value)}
                />
            )
        },
        {
            title: 'Interest Amount',
            width: 130,
            render: (_, record, index) => (
                <Input
                    size="small"
                    type="number"
                    value={record.interest_amount}
                    onChange={e => updateRecord(index, 'interest_amount', e.target.value)}
                />
            )
        },
        {
            title: 'EWSC Amount',
            width: 120,
            render: (_, record, index) => (
                <Input
                    size="small"
                    type="number"
                    value={record.ewsc_amount}
                    onChange={e => updateRecord(index, 'ewsc_amount', e.target.value)}
                />
            )
        },
        {
            title: 'EEC Amount',
            width: 120,
            render: (_, record, index) => (
                <Input
                    size="small"
                    type="number"
                    value={record.eec_amount}
                    onChange={e => updateRecord(index, 'eec_amount', e.target.value)}
                />
            )
        },
 {
    title: 'Status',
    width: 200,
    render: (_, record, index) => (
        <Segmented
            size="small"
            value={record.status}
            onChange={value => updateRecord(index, 'status', value)}
            options={[
                { label: 'Orders', value: 'Commitments/Orders' },
                { label: 'Desk', value: 'On Desk' },
                { label: 'Check', value: 'Checking' },
                { label: 'EFT', value: 'At EFT' },
                { label: 'Paid', value: 'Paid to Supplier' }
            ]}
        />
    )
},
        {
            title: 'Fiscal Year Period*',
            width: 140,
            render: (_, record, index) => (
                <Input
                    size="small"
                    value={record.fiscal_year_period}
                    onChange={e => updateRecord(index, 'fiscal_year_period', e.target.value)}
                    placeholder="e.g., 2024-2025"
                />
            )
        },
        {
            title: 'EFT Number',
            width: 120,
            render: (_, record, index) => (
                <Input
                    size="small"
                    value={record.eft_number}
                    onChange={e => updateRecord(index, 'eft_number', e.target.value)}
                />
            )
        },
        {
            title: 'Green Copy Date',
            width: 130,
            render: (_, record, index) => (
                <AntdDatepicker
                    size="small"
                    value={record.green_copy_date}
                    onChange={v => updateRecord(index, 'green_copy_date', v)}
                    style={{ width: '100%' }}
                />
            )
        },
        {
            title: 'Central Bank Swift',
            width: 140,
            render: (_, record, index) => (
                <Input
                    size="small"
                    value={record.central_bank_swift}
                    onChange={e => updateRecord(index, 'central_bank_swift', e.target.value)}
                />
            )
        },
        {
            title: 'Comment',
            width: 150,
            render: (_, record, index) => (
                <Input.TextArea
                    size="small"
                    value={record.comment}
                    onChange={e => updateRecord(index, 'comment', e.target.value)}
                    rows={1}
                />
            )
        },
        {
            title: 'Action',
            width: 80,
            fixed: 'right',
            render: (_, record, index) => (
                <Button
                    size="small"
                    type="link"
                    danger
                    onClick={() => removeRow(index)}
                    disabled={records.length === 1}
                >
                    Remove
                </Button>
            )
        }
    ];

    return (
        <Modal
            title="Bulk Expenditure Capture"
            open={showForm}
            onCancel={closeForm}
            destroyOnClose
            maskClosable={false}
            width="95%"
            style={{ top: 20 }}
            footer={[
                <Button key="cancel" onClick={closeForm}>
                    Cancel
                </Button>,
                <Button key="add" onClick={addRow}>
                    Add Row
                </Button>,
                <Button key="save" type="primary" onClick={saveAll}>
                    Save All ({records.length})
                </Button>
            ]}
        >
            <div style={{ marginBottom: 16 }}>
                <Text type="secondary">
                    * Required fields. Use Tab key to navigate between fields quickly.
                </Text>
            </div>
            
            <Table
                dataSource={records}
                columns={columns}
                pagination={false}
                scroll={{ x: 2500, y: 400 }}
                size="small"
                rowKey="id"
                bordered
            />
            
            {records.length === 0 && (
                <div style={{ textAlign: 'center', padding: '40px' }}>
                    <Text type="secondary">No records added yet. Click "Add Row" to start.</Text>
                </div>
            )}
        </Modal>
    );
});